import toast from 'react-hot-toast';
import { useFormat } from 'helpers/hooks/useFormat';

const useFeedbackToasts = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const notifyDataUpdated = () =>
    toast.success(formatMessage({ id: 'feedback.dataUpdated', defaultMessage: 'Dati aggiornati con successo.' }));

  const notifyWentWrong = () =>
    toast.error(
      formatMessage({ id: 'feedback.wentWrong', defaultMessage: 'Qualcosa è andato storto. Riprova più tardi.' }),
    );

  return { notifyDataUpdated, notifyWentWrong };
};

export default useFeedbackToasts;
